<tix-card class="bg-white p-6 max-w-[44rem] mx-auto">
  <ng-container *ngIf="isInvalidToken; else valid"> Invalid URL </ng-container>

  <ng-template #valid>
    <ng-container *ngIf="!isLoading; else spinner">
      <ng-container *ngIf="!isSuccess">
        <div class="mb-10">
          <h1 class="text-2xl font-semibold">Reset your password</h1>
          <p class="text-sm mt-2 text-gray-600">
            Enter your new password to complete the process.
          </p>
        </div>

        <form [formGroup]="resetForm" (submit)="handleSubmit($event)">
          <mat-form-field>
            <mat-label>New password</mat-label>
            <input formControlName="newPassword" type="password" matInput />
            <mat-error *ngIf="newPasswordControl.hasError('required')"
              >The new password is required</mat-error
            >
            <mat-error *ngIf="newPasswordControl.hasError('minlength')"
              >The new password has to be at least 8 characters</mat-error
            >
          </mat-form-field>

          <mat-form-field>
            <mat-label>Confirm password</mat-label>
            <input formControlName="confirmPassword" type="password" matInput />
            <mat-error *ngIf="confirmPasswordControl.hasError('required')"
              >The password confirmation is required</mat-error
            >
            <mat-error
              *ngIf="confirmPasswordControl.hasError('confirmedValidator')"
              >The passwords don't match</mat-error
            >
          </mat-form-field>

          <button
            [disabled]="resetForm.invalid || resetForm.pristine || isResetting"
            tix-button
            class="w-full h-12"
            type="submit"
          >
            <span *ngIf="!isResetting">Reset</span>
            <span *tixBtnLoading="isResetting"></span>
          </button>
        </form>
      </ng-container>

      <ng-container *ngIf="isSuccess">
        <div class="flex items-center justify-center my-4 flex-col">
          <tix-icon
            svgIcon="check-circle"
            class="inline-flex !h-14 !w-14 text-green-500 mb-6"
          ></tix-icon>
          <p class="text-center text-gray-600 mb-2">
            Your password has been reset successfully!
          </p>
          <button tix-button routerLink="../login">Go to login page</button>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #spinner>
      <div class="flex justify-center py-8">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    </ng-template>
  </ng-template>
</tix-card>
